// extracted by mini-css-extract-plugin
export default {"image":"eX-z","loaded":"fX-z"};